import { render, staticRenderFns } from "./ProductMenuSettingTabs.vue?vue&type=template&id=5196148e&"
import script from "./ProductMenuSettingTabs.ts?vue&type=script&lang=js&"
export * from "./ProductMenuSettingTabs.ts?vue&type=script&lang=js&"
import style0 from "./ProductMenuSettingTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports